import instance from "@/services/api";

export const tradingHouseAPI = {
  async getProviderRequests(params) {
    return await instance()
      .get("/provider_request/read_all/", { params })
      .then((res) => res?.data);
  },

  async getProviderRequestDetail(params) {
    return await instance()
      .get("/provider_request/read_detail/", { params })
      .then((res) => res?.data);
  },

  async getInvoiceItems(params) {
    return await instance()
      .get("/provider_request/read_invoice/", { params })
      .then((res) => res?.data);
  },

  async getRealizationItems(params) {
    return await instance()
      .get("/provider_request/read_realization/", { params })
      .then((res) => res?.data);
  },
};
